import { useMemo } from 'react'
import { useAtomValue } from 'jotai'

import type { Atom } from 'jotai'

export type FieldError = Record<string, string>

export const useFormFieldErrors = (fieldErrorsAtom: Atom<FieldError[]>) => {
  const fieldErrors = useAtomValue(fieldErrorsAtom)

  return useMemo(() => {
    const flags: Record<string, string[]> = {}
    for (const errorObj of fieldErrors) {
      for (const [field, error] of Object.entries(errorObj)) {
        if (!flags[field]) flags[field] = []
        flags[field].push(error)
      }
    }
    return flags
  }, [fieldErrors])
}
